/** A line of a newline-delimited JSON stream that is not valid JSON. */
export class NdjsonLineError extends Error {
  readonly line: string

  constructor(line: string) {
    super('Invalid NDJSON line')
    this.name = 'NdjsonLineError'
    this.line = line
  }
}

function parseLine(line: string): unknown {
  try {
    return JSON.parse(line)
  } catch {
    throw new NdjsonLineError(line)
  }
}

/** Yields one parsed value per non-empty line of a newline-delimited JSON byte stream. */
export async function* readNdjson(
  stream: ReadableStream<Uint8Array>,
): AsyncGenerator<unknown, void, undefined> {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffered = ''
  let finished = false
  try {
    while (!finished) {
      const chunk = await reader.read()
      if (chunk.done) {
        finished = true
        buffered += decoder.decode()
      } else {
        buffered += decoder.decode(chunk.value, { stream: true })
      }
      const lines = buffered.split('\n')
      buffered = finished ? '' : (lines.pop() ?? '')
      for (const line of lines) {
        const trimmed = line.trim()
        if (trimmed) yield parseLine(trimmed)
      }
    }
  } finally {
    if (!finished) await reader.cancel().catch(() => undefined)
    reader.releaseLock()
  }
}
